import info from "./status";
import { webinar } from "./module";
import { meetingService } from "../services/meeting";
import $ from "jquery";
import { URLS } from "fire-wind-water";

const w = window as any;

class PolyvSdk {
  static modules: { [label: string]: string | any }[] = [];
  player: any = {};
  plvDomainSdk: any = null;
  plvLiveSdk: any = null;
  isPlay: boolean;
  needPpt = true;
  pptObj: any;
  streamType = "play"; //视频 类型  live直播 playBack 回看
  idx = 0;
  videoPlayBackList: any = []; //当前的视频列表
  webcastId: any = "";
  videoBg: any = "";
  type: any = "";
  hlsSite: any = "";
  currentVideoId: any = "";
  webCastProvider: any = "";
  nowVideo: any = {};
  tenantId = "";
  userInfo: any = {};

  constructor(data) {
    this.streamType = data.type;
    this.tenantId = data.tenantId;
    this.type = data.type;
    this.webcastId = data.webcastId;
    this.pptObj = null;
    this.init(data);
  }
  init(data) {
    if (data.type == "live") {
      this.tenantId = data.tenantId;
      this.createLiveSdkPlayer();
    } else {
      this.tenantId = data.tenantId;
      this.needPpt = data.needPpt;
      this.videoPlayBackList = data.videoPlayBackList;
      this.nowVideo = data.nowVideo;
      if (data.nowVideo.videoType == "0") {
        this.plvDomainSdk = null;
        this.createLiveSdkPlayer();
      } else if (data.nowVideo.videoType == "1") {
        this.plvLiveSdk = null;
        this.createDomainSdkPlayer();
      }
    }
  }

  //保利威 直播sdk实例
  createLiveSdkPlayer() {
    const _this = this;
    this.userInfo = webinar.get().user;
    console.log("通过module获取用户信息", webinar.get().user);
    meetingService
      .getSign({
        tenantId: _this.tenantId,
        webcastId: _this.webcastId,
      })
      .then((signInfo) => {
        console.log("sk 获取签名", signInfo);
        this.plvLiveSdk = new w.PolyvLiveSdk({
          channelId: _this.webcastId,
          sign: signInfo.content.sign, //signStr
          timestamp: signInfo.content.timestamp,
          appId: signInfo.content.appId,
          user: {
            userId: _this.userInfo.uid,
            userName: _this.userInfo.name || "观众" + _this.userInfo.uid,
            pic: _this.userInfo.avatar
              ? _this.userInfo.avatar
              : "https://livestatic.videocc.net/assets/wimages/missing_face.png",
          },
        });
        // 监听频道信息并初始化播放器
        this.plvLiveSdk.on(w.PolyvLiveSdk.EVENTS.CHANNEL_DATA_INIT, () => {
          this.plvLiveSdk.setupPlayer({
            el: "#video",
            pptEl: "#plvPPt",
            type: _this.type == "live" ? "auto" : "vod", //播放器播放类型，'auto'(自动选择播放类型)、'live'(直播)、'vod'(回放)、'record'(暂存), 默认'auto'，选择'auto'后，播放器会以直播->回放列表视频->第一个暂存视频（优先级由大到小）的优先级播放
            controller: true, //是否显示控制栏, 因为设备兼容问题，在移动端中建议显示控制栏,默认true
            pptPlaceholder: true, //是否在直播模式并且当前暂无直播时在ppt区域显示占位图，默认false
            switchPlayer: false, //是否在控制栏显示ppt与player切换按钮，用于实现主副屏切换
            controllerPosition: "player", //控制栏显示在哪个区域 'ppt'（ppt区域）、'player'（讲师区域）, 默认ppt，因为考虑兼容的问题，该设置只在桌面端生效
            fixedController: false, //固定显示控制栏，设置后控制栏不跟随鼠标离开隐藏, 默认false，该设置只在桌面端生效
            defaultBarrageStatus: false, //播放器加载时弹幕转台是否显示开启，默认 true
            barrage: false, //是否开启弹幕，默认 false
            controllerEl: "",
            pptNav: false, //是否显示ppt控制控件，默认`true`
            pptNavBottom: "50px", //ppt控制栏距离底部距离
            vid:
              _this.type == "playback"
                ? _this.videoPlayBackList[_this.idx].voidId
                : "", //回放id，回放模式下传入该参数可不传fileId、url、sessionId 5d42445a8f7df21a06c21dbcf45c87e1_5
            autoplay: true, //是否自动播放，
            showPPTFullscreenButton: true, //是否在ppt中显示全屏按钮(移动端生效)
            skinConfig: {
              streamStop:
                "https://tf.smarket.net.cn/t/template/74033b16de0316e83957a3fc2a529e26/assets/images/video-bg-pc.jpg", //string 图片地址，用于修改暂无直播时居中图标
              streamPause:
                "https://tf.smarket.net.cn/t/template/74033b16de0316e83957a3fc2a529e26/assets/images/video-bg-pc.jpg", //string 图片地址，用于修改直播暂停状态时居中图标
              audioMode:
                "https://tf.smarket.net.cn/t/template/74033b16de0316e83957a3fc2a529e26/assets/images/video-bg-pc.jpg",
              audioModeVod:
                "https://tf.smarket.net.cn/t/template/74033b16de0316e83957a3fc2a529e26/assets/images/video-bg-pc.jpg",
            },
            theme: {
              playerBackgroundImage: false, // 讲师背景图，false 去掉默认背景图
            },
            lowLatency: true, //是否开启无延迟
          });
          //根据会议状态发送订阅消息
          if (this.plvLiveSdk.channelData.status === "Y") {
            info.sdk.thirdSubscribe.next({
              type: "skPlayerStatus",
              data: {
                content: { data: "直播" },
              },
            });
            info.ppt.thirdSubscribe.next({
              type: "skPptInfoChange",
              data: {
                isHavePpt: true, //当前视频是否有ppt  bollean
                pptIsOpen: true,
              },
            });
          } else {
            if (_this.type == "live") {
              info.sdk.videoStatus.next({
                content: { data: 2 },
              });
            } else {
              info.sdk.thirdSubscribe.next({
                type: "skPlayerStatus",
                data: {
                  content: { data: "直播回放" },
                },
              });
            }
            info.ppt.thirdSubscribe.next({
              type: "skPptInfoChange",
              data: {
                isHavePpt: false, //当前视频是否有ppt  bollean
                pptIsOpen: true,
              },
            });
          }
          //用户点击暂停
          this.plvLiveSdk.player.on("pause", () => {
            if (_this.type == "playback") {
              _this.pause();
            }
          });
          //用户恢复播放
          this.plvLiveSdk.player.on("playing", () => {
            if (_this.type == "playback") {
              _this.play();
            }
          });
          //视频播放完毕
          this.plvLiveSdk.player.on("ended", () => {
            if (_this.type == "playback") {
              _this.PlayOver();
            }
          });
          //视频加载成功可以准备播放，可对播放器进行play()、pause()等操作
          this.plvLiveSdk.player.on("loadedmetadata", () => {
            if (_this.type == "playback") {
              this.plvLiveSdk.player.play();
            }
            info.sdk.thirdSubscribe.next({
              type: "skPlayerInit",
              data: true,
            });
            // this.plvLiveSdk.player.switchPPTDocMode(true);
          });
          //隐藏显示PPT翻页控件
          this.plvLiveSdk.player.changePPTNavVisible(false);
          this.plvLiveSdk.player.on("pptStatusChange", function (data) {
            info.ppt.thirdSubscribe.next({
              type: "skPptInfoChange",
              data: {
                pptIsOpen: true, //目睹后端是否打开 显示ppt 开关 bollean
                pptUrl: "", //目睹后端当前ppt url str
                pptCurrentPageIndex: data.page, //目睹后端当前ppt 当前页码数 num
                pptTotalPage: data.total, //目睹后端当前ppt 总页码数 num
                pptIsAllowTurnPage: true, //目睹后端是否允许翻页  bollean
                isHavePpt: true,
              },
            });
            _this.resizePpt();
          });
          this.plvLiveSdk.player.on(
            "PPTFullscreenChange",
            function (fullscreen) {
              console.log(fullscreen ? "进入ppt全屏" : "退出ppt全屏");
            }
          );
          ///todo
          this.plvLiveSdk.player.on("switchMainScreen", (main) => {
            console.log("切换主讲位置，当前主屏为", main); // 'player'|'ppt'
            info.sdk.thirdSubscribe.next({
              type: "skPolyvNews",
              data: {
                content: { data: main, type: "switchMainScreen" },
              },
            });
          });

          $(".m-video-wrap").on("click", ".plv-live-player-mask", () => {
            this.plvLiveSdk.player.togglePlay();
          });
        });
        // 监听流状态变化
        this.plvLiveSdk.on(
          w.PolyvLiveSdk.EVENTS.STREAM_UPDATE,
          function (event, status) {
            if (status === "live") {
              // _this.plvLiveSdk.destroy(); // 直播JS-SDK销毁, 默认销毁时会断开socket的连接
              // _this.createLiveSdkPlayer();//重新加载播放器
              _this.plvLiveSdk.reloadPlayer(); //流状态更新时刷新播放器
              info.sdk.thirdSubscribe.next({
                type: "skPlayerStatus",
                data: {
                  content: { data: "直播" },
                },
              });
              info.ppt.thirdSubscribe.next({
                type: "skPptInfoChange",
                data: {
                  isHavePpt: true, //当前视频是否有ppt  bollean
                  pptIsOpen: true, //目睹后端是否打开 显示ppt 开关 bollean
                },
              });
            } else {
              info.sdk.thirdSubscribe.next({
                type: "skPlayerStatus",
                data: {
                  content: { data: "暂无直播" },
                },
              });

              info.ppt.thirdSubscribe.next({
                type: "skPptInfoChange",
                data: {
                  isHavePpt: false, //当前视频是否有ppt  bollean
                  pptIsOpen: true, //目睹后端是否打开 显示ppt 开关 bollean
                },
              });
            }
          }
        );

        this.plvLiveSdk.on(w.PolyvLiveSdk.EVENTS.ADD_SHIELD, () => {
          console.log("当前用户被禁止发言");
          info.sdk.thirdSubscribe.next({
            type: "skPolyvNews",
            data: {
              content: { data: "您已被禁言", type: "taboo" },
            },
          });
        });
        this.plvLiveSdk.on(w.PolyvLiveSdk.EVENTS.REMOVE_SHIELD, () => {
          console.log("当前用户被恢复发言");
          info.sdk.thirdSubscribe.next({
            type: "skPolyvNews",
            data: {
              content: { data: "您被恢复禁言", type: "recoveryTaboo" },
            },
          });
        });
        this.plvLiveSdk.on(w.PolyvLiveSdk.EVENTS.BAN_USER_ROOM, () => {
          console.log("当前用户被踢出房间");
          info.sdk.thirdSubscribe.next({
            type: "skPolyvNews",
            data: {
              content: { data: "您已经被踢出", type: "kickout" },
            },
          });
        });
      });
  }

  //保利威 点播sdk实例
  createDomainSdkPlayer() {
    this.userInfo = webinar.get().user;
    this.plvDomainSdk = new w.polyvPlayer({
      wrap: "#video",
      width: "100%",
      height: "100%",
      vid: this.nowVideo.voidId,
      showHd: false,
      speed: false,
      showLine: false,
      hideRepeat: false,
      viewerInfo: {
        viewerId: this.userInfo.memberId
          ? "user_" + this.userInfo.memberId
          : "webinar_" + URLS.getURL("webinarId"), // 观众ID
        viewerName: this.userInfo.name || "", // 观众昵称
      },
    });
    this.plvDomainSdk.on("s2j_onPlayerInitOver", () => {
      // info.sdk.pptInfoChange.next({
      //     isHavePpt: false, //当前视频是否有ppt  bollean
      //     pptIsOpen: true,  //todo 未验证是否有保利威关闭ppt 接口
      // });
      // info.sdk.isVideoPlayBackStatus.next({
      //     content: {data: "直播回放"}
      // });
      info.ppt.thirdSubscribe.next({
        type: "skPptInfoChange",
        data: {
          isHavePpt: false, //当前视频是否有ppt  bollean
          pptIsOpen: true, //todo 未验证是否有保利威关闭ppt 接口
        },
      });
      info.sdk.thirdSubscribe.next({
        type: "skPlayerStatus",
        data: {
          content: { data: "直播回放" },
        },
      });
      this.plvDomainSdk.on("s2j_onVideoPlay", () => {
        this.play();
      });
      this.plvDomainSdk.on("s2j_onVideoPause", () => {
        this.pause();
      });
      this.plvDomainSdk.on("s2j_onPlayOver", () => {
        this.PlayOver();
      });
    });
  }

  //视频初次播放或由暂停恢复播放
  play() {
    console.log("触发play  isPlay", this.isPlay);
    if (!this.isPlay) {
      this.isPlay = true;
      info.sdk.thirdSubscribe.next({
        type: "skPlayer",
        data: true,
      });
    }
  }

  //视频暂停
  pause() {
    this.isPlay = false;
    info.sdk.thirdSubscribe.next({
      type: "skStoped",
      data: true,
    });
  }

  // 视频播放完毕
  PlayOver() {
    //  播放结束看看视频是否是最后一个 不是的话 然后再去拿新的地址
    const videoList = this.videoPlayBackList;
    const index = this.idx;
    //当前视频播放结束后播放下一个视频
    if (index + 1 < videoList.length) {
      info.sdk.thirdSubscribe.next({
        type: "skSdkVideoChangeUrl",
        data: {
          href: videoList[index + 1],
          idx: index + 1,
        },
      });
    }
    //  播放结束看看视频是否是最后一个 不是的话 然后再去拿新的地址
    info.sdk.thirdSubscribe.next({
      type: "skEnded",
      data: this.isPlay,
    });
  }

  //  切换视频
  changeVideoUrl(data) {
    const _this = this;
    _this.idx = data.idx;
    _this.webcastId = data.webcastId || this.webcastId;
    _this.type = data.type || this.type;
    _this.hlsSite = data.hlsSite || this.hlsSite;
    _this.currentVideoId = data.currentVideoId || this.currentVideoId;
    _this.videoPlayBackList = data.videoPlayBackList || this.videoPlayBackList;
    _this.needPpt = data.needPpt || this.needPpt;
    _this.webCastProvider = data.webCastProvider || this.webCastProvider;
    _this.tenantId = data.tenantId;
    _this.nowVideo = data.nowVideo || this.nowVideo;
    _this.isPlay = data.isPlay;
    if (data.nowVideo.videoType == "0") {
      //直播转回放切换 视频
      if (_this.plvLiveSdk !== null) {
        _this.plvLiveSdk.switchVod({
          vid: data.nowVideo.voidId,
        });
      } else {
        $(".pv-video-player").remove(); //清除直播dom
        //如果是 wap video 内部所有元素 $(".pv-video-player").empty()
        // pv-video-player pv-skin_blue-40332635 pv-skin_blue-player pv-paused
        console.log(
          "%c当前设备是不是移动端？" +
            !!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)
            ? "是"
            : "不是",
          "color:red"
        );
        if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
          $("#video").empty();
        }
        _this.plvDomainSdk = null;
        _this.createLiveSdkPlayer();
      }
    } else {
      //点播切换视频
      if (_this.plvDomainSdk !== null) {
        _this.plvDomainSdk.changeVid({
          vid: data.nowVideo.voidId,
        });
      } else {
        $(".pv-ppt-layout").remove(); //清除直播dom
        if ($("#plvPPt .pv-ppt-layout")) {
          $("#plvPPt .pv-ppt-layout").remove(); //清除直播dom
        }
        _this.plvLiveSdk = null;
        _this.createDomainSdkPlayer();
      }
    }
  }

  //销毁
  remove() {
    if (this.plvDomainSdk) {
      this.plvDomainSdk.destroy();
    }
    if (this.plvLiveSdk) {
      this.plvLiveSdk.destroy();
    }
  }

  //ppt容器宽高修改，调用resize刷新ppt尺寸
  resizePpt() {
    setTimeout(() => {
      $("#pptAndPaintDiv").css({
        height: "100%",
        width: "100%",
        left: "0",
        top: "0",
        "margin-left": "0",
        "margin-top": "0",
      });
      this.plvLiveSdk.player.resize();
    }, 10);
  }

  onNext() {
    this.plvLiveSdk.player.nextPPTPage();
  }

  onPrev() {
    this.plvLiveSdk.player.prevPPTPage();
  }
}

export { PolyvSdk };
